import React, { Component } from 'react';
import { connect } from 'react-redux'



class GenerateQRCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //folderid: "DB43882D-E3A8-4885-8E5A-7F446292BA5B",
            //folderid: this.props.folderIdState,
            //qrprofiles: [],
            //objectid: this.props.currentObjectIdState[0],
            //userid: this.props.usedataState,
            //rodeid: this.props.roledataId,
            //taskid: this.props.taskIdState
        };

       

    }

  
  


    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search)
        var id = query.get('id')
    }

  
    render() {
        return (
            <div><span>thanasis</span></div>
        );
    }
}


const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        taskIdState: state.taskDataId,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        folderIdState: state.folderDataId,
        folderNameState: state.folderDataName,
        contextSelectionIdState: state.contextIdSelection,
        directoryIdState: state.directoryDataId,
        directoryNameState: state.directoryDataName,
        currentObjectIdState: state.currentObjectID,
        reduxState: state,
        contextConfig: state.currentContextConfiguration,
        actionMessage: state.currentActionmessage,
        themeState: state.currentThemeName,
        footerState: state.currFooterState,
        dashboardlist: state.currDashboardlistState,
        taskNotifications: state.currTaskNotificationState,
        folderNotifications: state.currFolderNotificationState,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderExpandCollapse: state.currFolderExpandCollapse,
        dashboardlist: state.currDashboardlistState,
        rootContextState: state.rootContext,
        rootSelectedState: state.rootSelected,
        multirootContext: state.currentActionmultiroot,
        windowpopupState: state.windowpopup,
        actionState: state.taaction,


    }
};
const mapDispatchToProps = dispatch => {
    return {


    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GenerateQRCode);
//export default SelectQRCodeProfile;


// WEBPACK FOOTER //
// ./src/components/WindowPopUp/GenerateQRCode.js